import { render, staticRenderFns } from "./CarrierContactInfo.vue?vue&type=template&id=9b54468a&"
import script from "./CarrierContactInfo.vue?vue&type=script&lang=js&"
export * from "./CarrierContactInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports